module.exports = __webpack_public_path__ + "static/media/07.ba55791c.gif";